import { Private_Routes } from '@common/url';
import { PackageList, usePackageList } from '@pages/PackageHub/package-list';
import { theme } from '@prophecy/theme';
import { Centered, Spinner, Stack } from '@prophecy/ui-v3';
import { useNavigate } from 'react-router-dom';

import { PackageBanner } from './components/PackageBanner';
import { PackageFilter } from './components/PackageFilter';

export const PackageHub = () => {
  const navigate = useNavigate();
  const { setFilter, filter, data, isLoading, teamNames, packages } = usePackageList();

  if (isLoading) {
    return (
      <Centered>
        <Spinner />
      </Centered>
    );
  }
  if (!data) {
    return null;
  }
  return (
    <Stack gap={theme.spaces.x40}>
      <PackageBanner />
      <PackageFilter filter={filter} setFilter={setFilter} teamNames={teamNames} packages={packages} />
      <PackageList
        selectedPackages={[]}
        packages={packages}
        onCardClick={(uid) => navigate(Private_Routes.Package.home.getUrl({ uid }))}
      />
    </Stack>
  );
};
